import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Spinner } from '@chakra-ui/react';
import { API } from '../services/API';

const SuperAdmin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const response = await API.get('/superadmin');
        if (response.data.status === 'success' && response.data.is_superadmin) {
          navigate('/superadmin/dashboard');
        } else {
          navigate('/chat');
        }
      } catch (error) {
        console.error('SuperAdmin check error:', error);
        navigate('/chat');
      }
    };

    checkAccess();
  }, [navigate]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <Spinner size="xl" />
    </Box>
  );
};

export default SuperAdmin;